.panel {
    display: flex;
    flex-direction: column;
    min-width: 0;
    background-color: var(--tempest-bg);
    color: var(--tempest-text);
    font-family: var(--tempest-font-sans);
}

.header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--tempest-space-3);
    padding: var(--tempest-space-3) var(--tempest-space-4);
    border-bottom: 1px solid var(--tempest-border);
}

.title {
    display: flex;
    align-items: center;
    gap: var(--tempest-space-2);
    margin: 0;
    font-size: var(--tempest-text-sm);
    font-weight: var(--tempest-weight-semibold);
}

.headerAction {
    padding: 0;
    border: none;
    background: none;
    color: var(--tempest-primary);
    font: inherit;
    font-size: var(--tempest-text-xs);
    cursor: pointer;
    white-space: nowrap;
}

.headerAction:hover {
    text-decoration: underline;
}

.headerAction:focus-visible {
    outline: 2px solid var(--tempest-primary);
    outline-offset: 2px;
    border-radius: var(--tempest-radius-sm);
}

.list {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    list-style: none;
    overflow-y: auto;
}

.item {
    display: flex;
    align-items: flex-start;
    gap: var(--tempest-space-3);
    padding: var(--tempest-space-3) var(--tempest-space-4);
    border-bottom: 1px solid var(--tempest-border);
}

.item:last-child {
    border-bottom: none;
}

/*
 * Unread is marked by a left bar plus a tinted background, never by colour alone
 * — the distinction has to survive a monochrome display and colour blindness.
 * `aria-current` on the row carries the same information non-visually.
 */
.item.unread {
    background-color: var(--tempest-surface);
    box-shadow: inset 3px 0 0 0 var(--tempest-primary);
}

.icon {
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: 2rem;
    height: 2rem;
    border-radius: var(--tempest-radius-full);
    background-color: var(--tempest-surface-2, var(--tempest-surface));
    color: var(--tempest-text-muted);
}

.body {
    display: flex;
    flex: 1;
    min-width: 0;
    flex-direction: column;
    gap: var(--tempest-space-1);
}

/*
 * The whole title/body block is one button so the hit target matches what the
 * user perceives as "the notification", instead of just its title text.
 */
.trigger {
    display: flex;
    flex-direction: column;
    gap: var(--tempest-space-1);
    padding: 0;
    border: none;
    background: none;
    color: inherit;
    font: inherit;
    text-align: left;
    cursor: pointer;
}

.trigger:focus-visible {
    outline: 2px solid var(--tempest-primary);
    outline-offset: 2px;
    border-radius: var(--tempest-radius-sm);
}

.itemTitle {
    font-size: var(--tempest-text-sm);
    font-weight: var(--tempest-weight-medium);
    line-height: var(--tempest-leading-snug);
}

.itemBody {
    color: var(--tempest-text-muted);
    font-size: var(--tempest-text-sm);
    line-height: var(--tempest-leading-normal);
}

.time {
    color: var(--tempest-text-muted);
    font-size: var(--tempest-text-xs);
}

.dismiss {
    flex-shrink: 0;
    width: 1.5rem;
    height: 1.5rem;
    padding: 0;
    border: none;
    border-radius: var(--tempest-radius-full);
    background: none;
    color: var(--tempest-text-muted);
    font-size: var(--tempest-text-base);
    line-height: 1;
    cursor: pointer;
}

@media (hover: hover) and (pointer: fine) {
    .dismiss:hover {
        background-color: var(--tempest-surface);
        color: var(--tempest-text);
    }
}

.dismiss:focus-visible {
    outline: 2px solid var(--tempest-primary);
    outline-offset: 2px;
}
